// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2ujIr","signatureButtonsRight":"ModalSign_signatureButtonsRight__3QvFS"};